import React from 'react';
import { Link } from 'react-router-dom';
import { useNotFoundSeo } from './useNotFoundSeo';
import './NotFoundPage.css';

const RECOVERY_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/compare', label: 'Compare' },
  { to: '/compatibility', label: 'Compatibility' },
  { to: '/price-comparison', label: 'Prices' },
];

export default function NotFoundPage() {
  useNotFoundSeo();

  return (
    <div className="ab-not-found" data-testid="not-found-page">
      <p className="ab-not-found-kicker">404</p>
      <h1 className="ab-not-found-title">Page not found</h1>
      <p className="ab-not-found-lede">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <nav className="ab-not-found-nav" aria-label="Helpful pages">
        {RECOVERY_LINKS.map((link) => (
          <Link key={link.to} className="ab-not-found-link" to={link.to}>
            {link.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}
